import { postJson } from '../../util/fetch-json.js';
import type { VisionLabel, VisionProvider } from '../provider.js';

export const serverVision: VisionProvider = {
  classifyPeople: async (jpegBase64) => {
    const r = await postJson<{ label: VisionLabel }>('/api/vision', { jpegBase64 });
    return r.label;
  },
};
